import { useState } from 'react';

function PartyTools({
  spinResult,
  spinning,
  onSpin,
  spinOptions,
  onDeleteSpin,
  dice,
  onRollDice,
  truth,
  dare,
  onPickTruth,
  onPickDare,
  onAddTruth,
  onAddDare,
  onAddSpin,
  truthOptions,
  dareOptions,
  onDeleteTruth,
  onDeleteDare,
}) {
  const [newTruth, setNewTruth] = useState('');
  const [newDare, setNewDare] = useState('');
  const [newSpin, setNewSpin] = useState('');
  const [showTruthList, setShowTruthList] = useState(false);
  const [showDareList, setShowDareList] = useState(false);
  const [showSpinList, setShowSpinList] = useState(false);
  const [truthAnimating, setTruthAnimating] = useState(false);
  const [dareAnimating, setDareAnimating] = useState(false);
  const [diceRolling, setDiceRolling] = useState(false);

  const runCycle = ({ action, duration = 3000, startDelay = 45, accelRatio = 0.88, decelRatio = 1.14 }) => {
    let elapsed = 0;
    let delay = startDelay;
    const accelUntil = duration * 0.6;
    const tick = () => {
      action();
      elapsed += delay;
      delay = elapsed < accelUntil ? Math.max(28, delay * accelRatio) : Math.min(400, delay * decelRatio);
      if (elapsed < duration) {
        setTimeout(tick, delay);
      }
    };
    tick();
  };

  const handleAddTruth = () => {
    if (!newTruth.trim()) return;
    onAddTruth?.(newTruth.trim());
    setNewTruth('');
  };

  const handleAddDare = () => {
    if (!newDare.trim()) return;
    onAddDare?.(newDare.trim());
    setNewDare('');
  };

  const handleAddSpin = () => {
    if (!newSpin.trim()) return;
    onAddSpin?.(newSpin.trim());
    setNewSpin('');
  };

  const triggerTruth = () => {
    if (truthAnimating) return;
    setTruthAnimating(true);
    runCycle({
      action: () => onPickTruth?.(),
      duration: 3000,
      startDelay: 45,
      accelRatio: 0.9,
      decelRatio: 1.12,
    });
    setTimeout(() => setTruthAnimating(false), 3200);
  };

  const triggerDare = () => {
    if (dareAnimating) return;
    setDareAnimating(true);
    runCycle({
      action: () => onPickDare?.(),
      duration: 3000,
      startDelay: 45,
      accelRatio: 0.9,
      decelRatio: 1.12,
    });
    setTimeout(() => setDareAnimating(false), 3200);
  };

  const triggerDice = () => {
    if (diceRolling) return;
    setDiceRolling(true);
    runCycle({
      action: () => onRollDice?.(),
      duration: 2000,
      startDelay: 38,
      accelRatio: 0.9,
      decelRatio: 1.12,
    });
    setTimeout(() => setDiceRolling(false), 2200);
  };

  return (
    <section className="panel">
      <div className="panel-head">
        <div>
          <p className="eyebrow">Party Assistant</p>
          <h2>Live Atmosphere Toolkit</h2>
        </div>
      </div>
      <div className="tool-grid">
        <div className="tool-card">
          <div className="tool-head">
            <span className="card-icon">🎡</span>
            <div>
              <p className="eyebrow">Random Decision</p>
              <h3>Mini Wheel</h3>
            </div>
          </div>
          <div className={`wheel ${spinning ? 'spin' : ''}`}>
            <div className="wheel-center">GO</div>
          </div>
          <button className="primary" onClick={onSpin} disabled={spinning}>
            {spinning ? 'Spinning...' : 'Spin it'}
          </button>
          <div className="result">{spinResult || 'Waiting for result'}</div>
          <div className="option-row">
            {spinOptions.map((o) => (
              <span key={o} className="chip soft">
                {o}
              </span>
            ))}
          </div>
          <div className="form-row">
            <input
              className="input"
            placeholder="Add a wheel option"
              value={newSpin}
              onChange={(e) => setNewSpin(e.target.value)}
            />
            <button className="secondary" onClick={handleAddSpin}>
            Add
            </button>
          </div>
          <button className="secondary ghost" onClick={() => setShowSpinList((v) => !v)}>
          {showSpinList ? 'Hide all options' : 'View / delete options'}
          </button>
          {showSpinList && (
            <div className="list-panel">
              {spinOptions.map((o, idx) => (
                <div key={`${o}-${idx}`} className="list-row">
                  <span className="list-text">{o}</span>
                  <button className="pill danger" onClick={() => onDeleteSpin?.(idx)}>
                    Delete
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="tool-card">
          <div className="tool-head">
            <span className="card-icon">🎲</span>
            <div>
              <p className="eyebrow">Quick Dice</p>
              <h3>On-site grouping / penalties</h3>
            </div>
          </div>
          <div className={`dice ${diceRolling ? 'rolling' : ''}`}>{dice}</div>
          <button className="primary" onClick={triggerDice}>
            Roll the dice
          </button>
          <p className="hint">Tap to decide order or penalty count</p>
          <div className="chip-row">
            <span className="chip soft">Grouping</span>
            <span className="chip soft">Penalty</span>
            <span className="chip soft">Draw lots</span>
          </div>
        </div>

        <div className="tool-card">
          <div className="tool-head">
            <span className="card-icon">🃏</span>
            <div>
              <p className="eyebrow">Icebreaker</p>
              <h3>Truth or Dare</h3>
            </div>
          </div>
          <div className="truth-dare">
            <div className="truth">
              <div className="pill">Truth</div>
              <p className={`prompt ${truthAnimating ? 'pulse' : ''}`}>{truth || 'Tap to draw a question'}</p>
              <button className="secondary" onClick={triggerTruth}>
                Draw
              </button>
              <div className="form-row">
                <input
                  className="input"
                  placeholder="Add a custom truth question"
                  value={newTruth}
                  onChange={(e) => setNewTruth(e.target.value)}
                />
                <button className="secondary" onClick={handleAddTruth}>
                  Add
                </button>
              </div>
              <button className="secondary ghost list-toggle" onClick={() => setShowTruthList((v) => !v)}>
                {showTruthList ? 'Hide all' : 'View / delete all'}
              </button>
              {showTruthList && (
                <div className="list-panel">
                  {truthOptions.map((item, idx) => (
                    <div key={`${item}-${idx}`} className="list-row">
                      <span className="list-text">{item}</span>
                      <button className="pill danger" onClick={() => onDeleteTruth?.(idx)}>
                        Delete
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="dare">
              <div className="pill">Dare</div>
              <p className={`prompt ${dareAnimating ? 'pulse' : ''}`}>{dare || 'Tap to draw a challenge'}</p>
              <button className="secondary" onClick={triggerDare}>
                Draw
              </button>
              <div className="form-row">
                <input
                  className="input"
                  placeholder="Add a custom dare"
                  value={newDare}
                  onChange={(e) => setNewDare(e.target.value)}
                />
                <button className="secondary" onClick={handleAddDare}>
                  Add
                </button>
              </div>
              <button className="secondary ghost list-toggle" onClick={() => setShowDareList((v) => !v)}>
                {showDareList ? 'Hide all' : 'View / delete all'}
              </button>
              {showDareList && (
                <div className="list-panel">
                  {dareOptions.map((item, idx) => (
                    <div key={`${item}-${idx}`} className="list-row">
                      <span className="list-text">{item}</span>
                      <button className="pill danger" onClick={() => onDeleteDare?.(idx)}>
                        Delete
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PartyTools;

